<mat-dialog-actions class="justify-content-between">
  <h3>{{ "LABEL.UPLOAD_MEDICAL_RECORD" | translate }}</h3>
  <button
    mat-icon-button
    mat-dialog-close
    class="d-flex justify-content-center"
  >
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="uploadForm">
    <div class="row">
      <div class="col-lg-12">
        <button matButton="tonal" color="primary" (click)="fileInput.click()">
          {{ "LABEL.CHOOSE_FILE" | translate }}
        </button>

        <input
          #fileInput
          type="file"
          hidden
          accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpeg,application/pdf"
          (change)="onFileChange($event)"
        />

        <span class="ml-2">
          {{ selectedFileName || "No file chosen" }}
        </span>

        <div class="mat-body-2 text-muted m-t-5">
          {{ "LABEL.ALLOWED_FILE_TYPES" | translate }}:
          {{ allowedFileTypesLabel }}.{{ "LABEL.MAX_FILE_SIZE" | translate }}
        </div>

        <mat-error
          *ngIf="
            uploadForm.get('file')?.touched && uploadForm.get('file')?.invalid
          "
        >
          {{ "VALIDATION.INVALID_IMAGE" | translate }}
        </mat-error>
      </div>
    </div>

    <!-- <div class="row m-t-10">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let type of medicalReportTypes" [value]="type">
              {{ medicalReportTypeLabels[type] }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->

    <div class="row m-t-10">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ "LABEL.DESCRIPTION_LABEL" | translate }}</mat-label>
          <textarea
            matInput
            placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}"
            rows="4"
            formControlName="description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions class="d-flex justify-content-end">
  <div class="row p-r-16">
    <div class="col-lg-8"></div>
    <div class="col-lg-4 d-flex justify-content-end">
      <button
        mat-stroked-button
        class="m-r-5"
        (click)="onCloseDialog(uploadForm.value)"
      >
        {{ "BUTTON.BTN_CLOSE" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="onUploadFile()"
        [disabled]="uploadForm.invalid || !selectedFile"
      >
        {{ "BUTTON.BTN_UPLOAD" | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
